export enum routes {
  DASHBOARD = '/dashboard',
  STORES = '/stores',
  EXPORTS = '/exports',
  PRODUCTS = '/products',
  LOGIN = '/login'
}
